import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { DockOverviewClone, DockOverviewInitialState, DockOverviewLoad } from './dock-overview.actions';
import { DockOverview } from '../../models';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { DockOverviewService } from './dock-overview.service';
import { NotificationService } from '../../../../../../common/services/notification/notification.service';
import { CLONE_DOCK_NAME_SUFFIX } from '../../constants';
import { Error, CustomHttpErrorResponse } from '../../../../../../common';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface DockOverviewStateModel {
  overview: DockOverview;
  loaded: boolean;
}

const initialState: DockOverviewStateModel = {
  overview: null,
  loaded: false,
};

@State<DockOverviewStateModel>({
  name: 'dockOverview',
  defaults: initialState,
})
@Injectable()
export class DockOverviewState {
  constructor(private dockOverviewService: DockOverviewService, private notificationService: NotificationService) {}

  @Selector()
  static getState(state: DockOverviewStateModel): DockOverviewStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: DockOverviewStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getName(state: DockOverviewStateModel): string {
    return state.overview?.name;
  }

  @Selector()
  static getOverview(state: DockOverviewStateModel): DockOverview {
    return state.overview;
  }

  @Action(DockOverviewLoad)
  getDockOverview(
    ctx: StateContext<DockOverviewStateModel>,
    { payload }: DockOverviewLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | DockOverviewStateModel> {
    return this.dockOverviewService.getOverviewData(payload).pipe(
      map((overview: DockOverview) => ctx.patchState({ overview, loaded: true })),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(DockOverviewClone)
  dockOverviewClone(
    ctx: StateContext<DockOverviewStateModel>,
    { payload }: DockOverviewClone,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | DockOverviewStateModel> {
    return this.dockOverviewService.getOverviewData(payload).pipe(
      map((overview: DockOverview) =>
        ctx.patchState({
          overview: {
            ...overview,
            id: null,
            name: `${overview.name}${CLONE_DOCK_NAME_SUFFIX}`,
          },
          loaded: true,
        }),
      ),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(DockOverviewInitialState)
  setInitialState(ctx: StateContext<DockOverviewStateModel>): void {
    ctx.setState(initialState);
  }
}
